import TablePagination from "@mui/material/TablePagination";
import * as React from "react";

const OverviewTablePagination = ({ rows, rowsPerPage, page, setPage, setRowsPerPage }) => {
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
                ".MuiTablePagination-toolbar": {
                    backgroundColor: "#333333",
                },
                ".MuiTablePagination-root": {
                    fontSize: "12px",
                },
                ".MuiTablePagination-input": {
                    fontSize: "12px",
                },
                ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                    fontSize: "12px",
                },
            }}
        />
    );
};

export default OverviewTablePagination;
